/**
 * Where the public site (apps/www) lives, for links from the app to its pages.
 *
 * The Terms of Use and Privacy Policy are pages on the public site, not screens
 * in the app, so there is one copy of each to keep correct. The default is the
 * production address; a local or staging build can point elsewhere.
 */
const DEFAULT_PUBLIC_SITE = "https://www.mapmymind.co.za";

export function publicSiteOrigin(): string {
  const configured = import.meta.env.VITE_PUBLIC_SITE_ORIGIN?.trim();
  return (configured || DEFAULT_PUBLIC_SITE).replace(/\/+$/, "");
}

export const TERMS_PATH = "/terms";
export const PRIVACY_PATH = "/privacy";
